"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const lodash_1 = require("lodash");
const Button_1 = require("@Components/Buttons/Button");
class InputWithButton extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "inputValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.value || ''
        });
        Object.defineProperty(this, "activeInputState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "onFocusInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => (this.activeInputState = true)
        });
        Object.defineProperty(this, "onBlurInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => (this.activeInputState = false)
        });
        Object.defineProperty(this, "handleChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                this.inputValue = event.target.value;
                this.onSave();
            }
        });
        Object.defineProperty(this, "onSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, lodash_1.debounce)(() => {
                this.props.onChange(this.inputValue, this.props.id);
            }, 200)
        });
        (0, mobx_1.makeObservable)(this, {
            inputValue: mobx_1.observable,
            activeInputState: mobx_1.observable,
            onFocusInput: mobx_1.action,
            onBlurInput: mobx_1.action,
            handleChange: mobx_1.action,
        });
    }
    render() {
        const { mainColor, id, type, errorMessage } = this.props;
        const classNames = [
            'input-with-button-component',
            mainColor ? 'main-color-set' : 'second-color-set',
            type,
            this.activeInputState ? 'focused' : '',
            this.inputValue ? 'filled' : '',
            errorMessage ? 'error' : '',
        ].join(' ');
        return (react_1.default.createElement("div", { className: classNames, "data-testid": 'input-with-button-component-' + id },
            react_1.default.createElement("div", { className: "input-wrapper" },
                react_1.default.createElement("input", { type: "email", id: id, onBlur: this.onBlurInput, onFocus: this.onFocusInput, onChange: this.handleChange, placeholder: !this.activeInputState ? 'Enter email...' : '' }),
                react_1.default.createElement(Button_1.Button, { mainColor: type === 'submit', type: 'primary' }, type === 'submit' ? 'Submit' : 'Sign-up')),
            errorMessage ? react_1.default.createElement("p", { className: "error-text small" }, errorMessage) : null));
    }
}
exports.default = (0, mobx_react_1.observer)(InputWithButton);
